exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sketch[data-v-7d0f1169]{width:60px;height:60px}.configure[data-v-7d0f1169]{cursor:move}.background[data-v-7d0f1169]{width:60px;height:60px;opacity:0}.picture[data-v-7d0f1169]{width:60px;height:60px;rx:10;ry:10;fill:#fff9ca;stroke:#333;stroke-width:1}.separator[data-v-7d0f1169]{stroke:#333;stroke-width:1px}.name[data-v-7d0f1169]{text-anchor:middle;font-size:12px;font-weight:700;-webkit-transform:translate(30px,10px);transform:translate(30px,10px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7d0f1169&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/region.vue
// module id = 33
// module chunks = 0